import React, {Component} from 'react'
import firebase from 'firebase/compat/app'
import Single from '../../../componentes/Single'
import 'firebase/compat/database';
import { Form, Modal, Button, Icon } from 'semantic-ui-react'

class MoverHerramienta extends Component{
	constructor(props){
		super(props)
		this.app= firebase;
		this.database = this.app.firestore().collection('InventarioH')
		this.state = {
			id: this.props.data.id,
			ubicacion: this.props.data.ubicacion,
			nombre: this.props.data.herramienta,
			fecha: '',
			almacenes: []
		}
        this.useModal = false;
		this.pasadoPor = this.props.pasadoPor
	}
	componentDidMount() {
        const docRef = this.app.firestore().collection('Info').doc('info');
        docRef.get().then((doc) => {
        if (doc.exists) {
            this.setState({ almacenes: doc.data().almacenes });
        } else {
            console.log('No such document!');
        }
        }).catch((error) => {
        console.log('Error getting document:', error);
        });
    }
    changeUsModal=(e)=>{
		this.setState({useModal:e})
	}
    guardarDatos= async ()=>{
        const newdata = this.database.doc(this.state.id)
        try {
            newdata.update({
                herramienta: this.state.nombre,
                ubicacion: this.state.ubicacion,
				fecha: this.state.fecha,
				pasadoPor: this.pasadoPor,
            })
			alert("Datos Guardados Correctamente")
        } catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
		this.props.actualizar()
    }
    handleChange = async (e, { name, value }) => {
        const fecha = firebase.firestore.Timestamp.now()
		this.setState({[name]: value, fecha: fecha})
	}
	borrar= async (id)=>{
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
		this.changeUsModal(false)
	}
	render(){
		return (
		<>
			<button className='editar' onClick={() => this.changeUsModal(true)}><Icon name='edit' /></button>
			<Modal 
				onClose={() => this.changeUsModal(false)}
				onOpen={() => this.changeUsModal(true)}
				open={this.state.useModal}>
				<Modal.Header>
					Herramienta: {this.state.nombre} 
				</Modal.Header>
				<Modal.Content>
				<Form>
                    <Form.Field required>
						<label>Pasar a:</label> 
						<Single
                            onChange={this.handleChange}
                            name='ubicacion'
                            columna='Nombre'
                            tabla='Empleados'
                            filtro1='activo' filtro2='==' filtro3='si'
							incluir={this.state.almacenes}
                        />
					</Form.Field>
                    <Form.Field required>
						<label>Fecha: {this.state.fecha?this.state.fecha.toDate().toLocaleDateString():null}</label> 
					</Form.Field>

				</Form>
				</Modal.Content>
                <Modal.Actions>
                    <Button onClick={()=>this.guardarDatos()}>Guardar</Button>
				</Modal.Actions>
			</Modal>
		</>
		)
	}
}

export default MoverHerramienta;